module.exports = __webpack_public_path__ + "static/media/footer-gmadpay.9c0d0dad.jpg";